import { registerSW } from "virtual:pwa-register";
import { dropStaleApiCaches } from "./api-cache";
import { markUpdatePending, reloadIfUpdatePending } from "./update-state";

const UPDATE_CHECK_MS = 60 * 60 * 1000;

// Registers the Workbox service worker (autoUpdate): a new build is activated at once, the page
// reloads at the next safe moment (route change or hidden tab, see `update-state.ts`) so the
// running code matches the precache; hourly update checks keep installed sessions current.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  void dropStaleApiCaches();
  registerSW({
    immediate: true,
    onNeedReload: markUpdatePending,
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => void registration.update(), UPDATE_CHECK_MS);
    },
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") reloadIfUpdatePending();
  });
}
